<script>
	import { getContext, onDestroy } from 'svelte'
	import { storeFreeRooms, storeOldBookings } from '../../../library/scripts/Store.svelte'
	import { admin } from '../../../library/scripts/PhpHandler.svelte'
	import { fetch_rooms_from_db } from '../AdminModule.svelte'
	import {
		eachDayOfInterval,
		isWithinInterval,
		areIntervalsOverlapping,
		subDays,
		isBefore,
		isAfter,
		add,
		format,
		isEqual,
	} from 'date-fns'
	import { get_username } from '../../../library/scripts/utils'
	import { getCookie } from '../../../library/scripts/cookie'
	import { validate } from '../../../library/scripts/validate'
	import { slide } from 'svelte/transition'
	import { styles } from '../../../library/scripts/styles'
	import Active from './Active.svelte'
	import Upcoming from './Upcoming.svelte'
	import Completed from './Completed.svelte'
	import Revenue from './Revenue.svelte'
	import OldBookings from './ViewPDF.svelte'
	import TwoCols from '../../../library/columLayouts/ThreeCols.svelte'
	import ThreeCols from '../../../library/columLayouts/ThreeCols.svelte'
	import DatePicker from '../../../library/LayoutStuff/DatePicker.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsX = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const colorMain = globals.colorMain
	const colorPassive = globals.colorError

	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover
	const inputBg = globals.inputBg
	const inputFocus = globals.inputFocus
	const bg = globals.bgDark

	const userID = getCookie('id')
	
	//show/hide tools
	let showBooking = false
	let showActive = false
	let showUpcoming = false
	let showRevenue = false
	let showViewPDF = false
	let showCompleted = false
	let showBookButton = false
	let showCancelButton = false
	let showCheck = true

	//load the rooms & booked periods from db
	let rooms = fetch_rooms_from_db()
	let currency = 'USD'

	//error messages
	let startError = false
	let endError = false
	const sEMsg = 'check-in before todyay'
	const eEMsg = 'check-out before check-in'

	//set dates
	let today = new Date()
	let tmrw = add(today, { days: 1 })
	today = format(today, 'dd/MM/yyyy')
	tmrw = format(tmrw, 'dd/MM/yyyy')

	//split today for use in new Date
	let todaySplit = today.split('/')

	let bookingDates = { start: today, end: tmrw }

	//all rooms
	let allRooms = []

	//the full roms
	let fullRooms = []

	//the free rooms
	let freeRooms = []

	//booked days & finances
	let bookedDays = 0
	let totalAmount = 0

	//show the free rooms & bookings input
	let showFreeRooms = false
	let showInput = false

	//high-low number of days
	let totalHigh = 0
	let totalLow = 0

	//the room to book
	let roomNumber
	let roomDescription

	//user credentials
	let name = ''
	let email = ''
	let phone = ''
	let specials = ''
	let guests = 1
	let maxGuests = 1

	// error handling
	let errorOffline = false
	let errorName = false
	let errorPhone = false
	let errorMail = false
	let errorMessage = ''

	//the booking details
	let sendBooking = {}

	// arrival time
	let arrivalTime = '12:00- 14:00'

	//breakfast etc
	let breakfast

	//sending
	let send = false
	let answer = false

	//delete old bookings alert
	let bookingAlert = false

	//no bookings deleted
	let nodelete = false

	const booking_alert_delete = () => {
		bookingAlert = bookingAlert === false ? true : false
	}

	//delete old bookngs
	const delete_old_bookings = async () => {
		
		const bkFile = await admin({ cmd: 'delete_old_bookings', userid: userID })

		if (bkFile !== 'nofile') {
			storeOldBookings.set([bkFile])
			booking_alert_delete()
		} else {
			booking_alert_delete()
			nodelete = true
			const toNoDel = setTimeout(() => {
				nodelete = false
				clearTimeout(toNoDel)
			}, 2000)
		}
	}

	//open/close tools
	const open_tool = (t) => {
		if (t === 'booking') {
			showBooking = showBooking === true ? false : true
			showUpcoming = false
			showRevenue = false
			showCompleted = false
			showActive = false
			showViewPDF = false
		}

		if (t === 'open') {
			showBooking = false
			showUpcoming = showUpcoming === true ? false : true
			showRevenue = false
			showCompleted = false
			showActive = false
			showViewPDF = false
		}

		if (t === 'revenue') {
			showBooking = false
			showUpcoming = false
			showRevenue = showRevenue === true ? false : true
			showCompleted = false
			showActive = false
			showViewPDF = false
		}

		if (t === 'closed') {
			showBooking = false
			showUpcoming = false
			showRevenue = false
			showCompleted = showCompleted === true ? false : true
			showActive = false
			showViewPDF = false
		}

		if (t === 'active') {
			showBooking = false
			showUpcoming = false
			showRevenue = false
			showCompleted = false
			showActive = showActive === true ? false : true
			showViewPDF = false
		}

		if (t === 'showpdf') {
			showBooking = false
			showUpcoming = false
			showRevenue = false
			showCompleted = false
			showActive = false
			showViewPDF = showViewPDF === true ? false : true
		}
	}

	const reset_error = () => {
		errorOffline = false
		errorMessage = ''
	}

	const close_booking = () => {
		answer = false
		showInput = false
		showBookButton = false
		showFreeRooms = false
		showCheck = true
		showCancelButton = false
		totalHigh = 0
		totalLow = 0
		totalAmount = 0
		name = ''
		phone = ''
		email = ''
		specials = ''
		guests = 1
	}

	const cancel_booking = () => {
		showCheck = true
		showCancelButton = false
		showBookButton = false
		showInput = false
		showFreeRooms = false
		storeFreeRooms.set([])
		totalHigh = 0
		totalLow = 0
		totalAmount = 0
	}

	const book_room = async () => {
		const vName = validate('input', name)
		if (!vName) {
			errorName = true
			errorMessage = 'please enter your name'
			const toError = setTimeout(() => {
				errorName = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)
			return
		}

		const vPhone = validate('phone', phone)
		if (!vPhone) {
			errorPhone = true
			errorMessage = 'please enter phone-number'
			const toError = setTimeout(() => {
				errorPhone = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)
			return
		}

		const vMail = validate('email', email)
		if (!vMail) {
			errorMail = true
			errorMessage = 'please enter a valid email-address'
			const toError = setTimeout(() => {
				errorMail = false
				errorMessage = ''
				clearTimeout(toError)
			}, 2000)
			return
		}

		sendBooking.name = name
		sendBooking.phone = phone
		sendBooking.email = email
		sendBooking.guests = guests
		sendBooking.arrival = arrivalTime
		sendBooking.specials = specials

		//the send object
		
			send = true
			const sendBook = await admin({ cmd: 'make_booking', data: sendBooking })

			if (sendBook) {
				send = false
				answer = true
				const toResponse = setTimeout(() => {
					close_booking()
					clearTimeout(toResponse)
				}, 2000)
			}
		
	}

	const set_date = (e) => {
		if (e.detail.cmd === 'start') bookingDates.start = e.detail.value
		if (e.detail.cmd === 'end') {
			bookingDates.end = e.detail.value
			showCheck = false
			get_free_rooms()
		}
	}

	//get the room details from DB
	const seasons = admin({
		cmd: 'get_seasons',
	})

	const show_book_room = (r) => {
		//reset booked days
		bookedDays = 0
		roomNumber = r
		showInput = true
		showBookButton = true
		showFreeRooms = false
		let highPrice = 0
		let lowPrice = 0
		let totalPrice = 0
		let startIntDay
		let endIntDay
		let totBooked

		//get the low & high season prices
		let start = bookingDates.start.split('/')
		let bookOut = bookingDates.end.split('/')
		let end = new Date(bookOut[2], parseInt(bookOut[1]) - 1, bookOut[0])
		end = subDays(end, 1)
		end = format(end, 'dd/MM/yyyy')
		end = end.split('/')

		//get the details for room
		seasons.then((s) => {
			s.fetch.forEach((sF) => {
				startIntDay = sF[1].split('/')
				endIntDay = sF[2].split('/')
				totBooked = eachDayOfInterval({
					start: new Date(start[2], parseInt(start[1]) - 1, start[0]),
					end: new Date(end[2], parseInt(end[1]) - 1, end[0]),
				})

				bookedDays = totBooked.length

				//get high/low season
				totBooked.forEach((tB) => {
					const checkSeas = isWithinInterval(tB, {
						start: new Date(startIntDay[2], parseInt(startIntDay[1]) - 1, startIntDay[0]),
						end: new Date(endIntDay[2], parseInt(endIntDay[1]) - 1, endIntDay[0]),
					})

					if (checkSeas) totalHigh += 1
					totalLow = bookedDays - totalHigh
				})

				freeRooms.forEach((r) => {
					if (r.number === roomNumber) {
						roomDescription = r.description
						highPrice = totalHigh * parseFloat(r.high)
						lowPrice = totalLow * parseFloat(r.low)
						totalPrice = highPrice + lowPrice
						breakfast = r.breakfast === '1' ? 'included' : 'not included'
						maxGuests = r.guests
						currency = r.currency

						sendBooking = {
							name: name,
							phone: phone,
							specials: specials,
							email: email,
							guests: guests,
							room: roomNumber,
							checkin: bookingDates.start,
							checkout: bookingDates.end,
							days: bookedDays,
							totalLow: totalLow,
							low: lowPrice,
							totalHigh: totalHigh,
							high: highPrice,
							total: totalPrice,
							currency: currency,
							breakfast: breakfast,
							arrival: arrivalTime,
						}
					}
				})
			})
		})
		showInput = true
	}

	const get_free_rooms = () => {
		showCancelButton = true
		showCheck = false
		const rooms = fetch_rooms_from_db()
		const checkIn = bookingDates.start.split('/')
		const checkOut = bookingDates.end.split('/')
		//empty old arrays
		allRooms = []
		freeRooms = []
		fullRooms = []
		let within = null

		//error handling startDate is before today && endDate is before startDate
		const errorStart = isBefore(
			new Date(checkIn[2], parseInt(checkIn[1] - 1), checkIn[0]),
			new Date(todaySplit[2], parseInt(todaySplit[1] - 1), todaySplit[0])
		)
		const errorEnd = isBefore(
			new Date(checkOut[2], parseInt(checkOut[1] - 1), checkOut[0]),
			new Date(checkIn[2], parseInt(checkIn[1] - 1), checkIn[0])
		)

		if (errorStart) {
			startError = true
			bookingDates.start = today
			const toES = setTimeout(() => {
				startError = false
				clearTimeout(toES)
			}, 2000)
			return
		}

		if (errorEnd) {
			endError = true
			const toEE = setTimeout(() => {
				endError = false
				clearTimeout(toEE)
			}, 2000)
			return
		}

		rooms.then((value) => {
			if (value) {
				value.forEach((r) => {
					//no bookings yet
					if (r.bookings === '' && !freeRooms.includes(r)) freeRooms.push(r)

					//split the periods
					if (r.bookings !== '') {
						allRooms.push(r)
						const periods = r.bookings.split(',')

						periods.forEach((p) => {
							const start = p.split('-')[0].split('/')
							const end = p.split('-')[1].split('/')

							//don't count the check-out day
							const periodOut = new Date(end[2], parseInt(end[1]) - 1, end[0])
							const lastDay = subDays(periodOut, 1)

							//only if last Day of bookings is equal or after today (exclude old bookings)
							const afterDate = isAfter(lastDay, new Date(todaySplit[2], parseInt(todaySplit[1]) - 1, todaySplit[0]))
							const equalDate = isEqual(lastDay, new Date(todaySplit[2], parseInt(todaySplit[1]) - 1, todaySplit[0]))

							if (afterDate || equalDate) {
								within = isWithinInterval(new Date(checkIn[2], parseInt(checkIn[1]) - 1, checkIn[0]), {
									start: new Date(start[2], parseInt(start[1]) - 1, start[0]),
									end: lastDay,
								})

								if (within && !fullRooms.includes(r)) fullRooms.push(r)

								// overlapping periods
								const overlapp = areIntervalsOverlapping(
									{ start: new Date(start[2], parseInt(start[1]) - 1, start[0]), end: lastDay },
									{
										start: new Date(checkIn[2], parseInt(checkIn[1]) - 1, checkIn[0]),
										end: new Date(checkOut[2], parseInt(checkOut[1]) - 1, checkOut[0]),
									}
								)

								if (overlapp && !fullRooms.includes(r)) fullRooms.push(r)
							}
						})
					}
				})
				const fRooms = allRooms.filter((x) => fullRooms.indexOf(x) === -1)
				freeRooms = [...fRooms, ...freeRooms]

				storeFreeRooms.set(freeRooms)
				showFreeRooms = true
			}
		})
	}
</script>

{#await rooms}
	<Spinner color="hsl(0,0%,60%)" size="4vw" info="content updating" fontsize={fsXS} />
{:then r}
	{#if !r}
		<div class="title_container subtitle" use:styles={{ fsN, colorMain }}>NO ROOMS SET</div>
	{:else if !send && !answer}
		<div class="title_container">
			{#if showBooking}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Check/Book Room</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					on:click={() => open_tool('booking')}
					on:keydown={() => open_tool('booking')}
				>
					Check/Book Room
				</button>
			{/if}
			{#if showActive}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Active Bookings</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					on:click={() => open_tool('active')}
					on:keydown={() => open_tool('active')}
				>
					Active Bookings
				</button>
			{/if}
			{#if showUpcoming}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Open Bookings</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					on:click={() => open_tool('open')}
					on:keydown={() => open_tool('open')}
				>
					Open Bookings
				</button>
			{/if}

			{#if showCompleted}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Closed Bookings</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					on:click={() => open_tool('closed')}
					on:keydown={() => open_tool('closed')}
				>
					Closed Bookings
				</button>
			{/if}

			{#if showRevenue}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Revenue</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					use:styles={{ fsX, colorMain }}
					on:click={() => open_tool('revenue')}
					on:keydown={() => open_tool('revenue')}
				>
					Revenue
				</button>
			{/if}

			<button use:styles={{ fsS, buttonColor, buttonHover }} on:click={booking_alert_delete}>
				delete old bookings</button
			>

			{#if showViewPDF}
				<div class="selected_tool" use:styles={{ fsS, buttonColor, buttonHover }}>Old Bookings</div>
			{:else}
				<button
					use:styles={{ fsS, buttonColor, buttonHover }}
					use:styles={{ fsX, colorMain }}
					on:click={() => open_tool('showpdf')}
					on:keydown={() => open_tool('showpdf')}
				>
					Old Bookings
				</button>
			{/if}
		</div>
		<hr />
		{#if showBooking}
			<div class="set_bg" use:styles={{ bg }} transition:slide={{ duration: 500 }}>
				{#if showCheck}
					<div class="subtitle" style="cursor:pointer;" use:styles={{ fsN, colorMain }}>Check Room</div>
					<div class="date_container">
						<div class="date_row">
							<div class="subtitle" use:styles={{ fsN, colorMain }}>check-in</div>
							{#if !startError}
								<DatePicker
									cmd="start"
									backgroundColor="transparent"
									color={colorMain}
									colorDisabled="hsl(0,0%,50%)"
									disablePrevious={true}
									selectionDate={true}
									on:getdate={set_date}
								/>
							{:else}
								<div class="error" use:styles={{ fsN, colorPassive }}>{sEMsg}</div>
							{/if}
						</div>
						<div class="date_row">
							<div class="subtitle" use:styles={{ fsN, colorMain }}>check-out</div>

							{#if !endError}
								<DatePicker
									cmd="end"
									backgroundColor="transparent"
									color={colorMain}
									colorDisabled="hsl(0,0%,50%)"
									disablePrevious={true}
									on:getdate={set_date}
								/>
							{:else}
								<div class="error" use:styles={{ fsN, colorPassive }}>{eEMsg}</div>
							{/if}
						</div>
					</div>
					<hr />
				{/if}

				{#if showFreeRooms}
					<div transition:slide={{ duration: 500 }}>
						<div class="subtitle" style="cursor:pointer;" use:styles={{ fsN, colorMain }}>Free Rooms</div>
						{#if freeRooms.length === 0}
							<div class="subtitle" style="color:red" use:styles={{ fsN, colorMain }}>FULLY BOOKED</div>
						{:else if freeRooms.length > 0}
							<div class="free_button_container">
								{#each $storeFreeRooms as room}
									<div>
										<button use:styles={{ fsS, buttonColor, buttonHover }} on:click={() => show_book_room(room.number)}>
											Room {room.number}</button
										>
									</div>
								{/each}
							</div>
						{/if}
					</div>
				{/if}

				{#if showInput}
					<div transition:slide={{ duration: 500 }}>
						<div class="container" use:styles={{ bg }}>
							<div class="subtitle" use:styles={{ fsN, colorMain }}>
								Book Room {roomNumber} ({roomDescription})
							</div>

							<TwoCols>
								<div slot="column1">
									<div class="label" use:styles={{ fsN, colorMain }}>Name</div>
									{#if errorName}
										<div class="error" use:styles={{ colorPassive, fsN }}>{errorMessage}</div>
									{:else}
										<input
											type="text"
											use:styles={{ fsN, inputBg, inputFocus, colorMain }}
											bind:value={name}
											placeholder="name"
										/>
									{/if}

									<div class="label" use:styles={{ fsN, colorMain }}>Phone</div>
									{#if errorPhone}
										<div class="error" use:styles={{ colorPassive, fsN }}>{errorMessage}</div>
									{:else}
										<input
											type="text"
											use:styles={{ fsN, inputBg, inputFocus, colorMain }}
											bind:value={phone}
											placeholder="phone"
										/>
									{/if}
									<div class="label" use:styles={{ fsN, colorMain }}>Email</div>
									{#if errorMail}
										<div class="error" use:styles={{ colorPassive, fsN }}>{errorMessage}</div>
									{:else}
										<input
											type="text"
											use:styles={{ fsN, inputBg, inputFocus, colorMain }}
											bind:value={email}
											placeholder="email"
										/>
									{/if}
								</div>
								<div slot="column2">
									<div class="label" use:styles={{ fsN, colorMain }}>Guests</div>
									<input
										type="number"
										use:styles={{ fsN, inputBg, inputFocus, colorMain }}
										min="1"
										max={maxGuests}
										bind:value={guests}
									/>
									<div class="label" use:styles={{ fsN, colorMain }}>Arrival Time</div>
									<select bind:value={arrivalTime} use:styles={{ fsN, inputBg, inputFocus, colorMain }}>
										<option selected={arrivalTime}>{arrivalTime}</option>
										<option value="00:00 - 02:00">00:00 - 02:00</option>
										<option value="02:00 - 04:00">02:00 - 04:00</option>
										<option value="04:00 - 06:00">04:00 - 06:00</option>
										<option value="06:00 - 08:00">06:00 - 08:00</option>
										<option value="08:00 - 10:00">08:00 - 10:00</option>
										<option value="10:00 - 12:00">10:00 - 12:00</option>
										<option value="12:00 - 14:00">12:00 - 14:00</option>
										<option value="14:00 - 16:00">14:00 - 16:00</option>
										<option value="16:00 - 18:00">16:00 - 18:00</option>
										<option value="18:00 - 20:00">18:00 - 20:00</option>
										<option value="20:00 - 22:00">20:00 - 22:00</option>
										<option value="22:00 - 00:00">22:00 - 00:00</option>
									</select>

									<div class="label" use:styles={{ fsN, colorMain }}>Specials</div>

									<textarea
										use:styles={{ fsN, inputBg, inputFocus, colorMain }}
										bind:value={specials}
										placeholder="specials"
									/>
								</div>
							</TwoCols>
						</div>
						<hr />
						<div class="container">
							<div class="subtitle" use:styles={{ fsN, colorMain }}>
								Confirmation Room {roomNumber} --
								{sendBooking.checkin} - {sendBooking.checkout}
							</div>
							<div class="subtitle" use:styles={{ fsN, colorMain }}>
								<div class="label margin_right" use:styles={{ fsN, colorMain }}>arrival time {arrivalTime}</div>
							</div>
							<ThreeCols>
								<div slot="column1">
									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>name</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{name}</div>
									</div>

									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>phone</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{phone}</div>
									</div>

									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>email</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{email}</div>
									</div>
									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>guests</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{guests}</div>
									</div>
								</div>
								<div slot="column2">
									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>breakfast</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{breakfast}</div>
									</div>
									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>low season</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{totalLow} days</div>
									</div>

									<div class="conf_date_row">
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>high season</div>
										<div class="label margin_right" use:styles={{ fsN, colorMain }}>{totalHigh} days</div>
									</div>

									<div class="conf_date_row">
										<div class="label margin_right bold" use:styles={{ fsN, colorMain }}>total</div>
										<div class="label margin_right bold underline" use:styles={{ fsN, colorMain }}>
											{sendBooking.currency}
											{sendBooking.total}
										</div>
									</div>
								</div>

								<div slot="column3">
									<div class="conf_date_row">
										<div class="label margin_right underline" use:styles={{ fsN, colorMain }}>specials</div>
									</div>

									<div class="conf_date_row">
										<div class="label margin_right span_row" use:styles={{ fsN, colorMain }}>{specials}</div>
									</div>
									<div></div>
									<div></div>
								</div>
							</ThreeCols>
						</div>
					</div>
				{/if}

				<div class="button_container" use:styles={{ bg }}>
					{#if showBookButton}
						<button on:click={book_room} use:styles={{ fsS, buttonColor, buttonHover }}>book</button>
					{/if}

					{#if showInput}
						<button on:click={close_booking} use:styles={{ fsS, buttonColor, buttonHover }}>close</button>
					{/if}

					{#if showCancelButton}
						<button on:click={cancel_booking} use:styles={{ fsS, buttonColor, buttonHover }}>cancel</button>
					{/if}
				</div>
			</div>
		{/if}

		{#if showActive}
			<div transition:slide={{ duration: 500 }}><Active /></div>
		{/if}

		{#if showUpcoming}
			<div transition:slide={{ duration: 500 }}><Upcoming /></div>
		{/if}

		{#if showCompleted}
			<div transition:slide={{ duration: 500 }}><Completed /></div>
		{/if}

		{#if showRevenue}
			<div transition:slide={{ duration: 500 }}><Revenue /></div>
		{/if}

		{#if showViewPDF}
			<div transition:slide={{ duration: 500 }}><OldBookings /></div>
		{/if}
	{/if}

	<!-- sending -->
	{#if send && !answer}
		<Shader>
			<div slot="content">
				<Alert
					message="send booking"
					spinner={true}
					showOkButton={false}
					showCancelButton={false}
					alertMessage="BOOKING"
				/>
			</div>
		</Shader>
	{/if}

	{#if !send && answer}
		<Shader>
			<div slot="content">
				<Alert message="booking confirmed" showOkButton={false} showCancelButton={false} alertMessage="CONFIRMATION" />
			</div>
		</Shader>
	{/if}
	{#if errorOffline}
		<Shader>
			<div slot="content">
				<Alert message={errorMessage} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
			</div>
		</Shader>
	{/if}

	{#if bookingAlert}
		<Shader>
			<div slot="content">
				<Alert
					message="Delete old bookings from the database.You can manage them by clicking on the OLD BOOKINGS button."
					message2="your deleted bookings will be saved"
					alertMessage="BOOK KEEPING"
					on:alertclose={booking_alert_delete}
					on:alertok={delete_old_bookings}
				/>
			</div>
		</Shader>
	{/if}

	{#if nodelete}
		<Shader>
			<div slot="content">
				<Alert
					message="There where no old bookings on the DB"
					message2="no bookings deleted"
					alertMessage="BOOK KEEPING"
					showOkButton={false}
					showCancelButton={false}
				/>
			</div>
		</Shader>
	{/if}
{/await}

<style>
	.label {
		color: var(--colorMain);
		font-size: var(--fsN);
		margin-bottom: 10px;
	}

	input[type='text'] {
		outline: none;
		font-size: var(--fsN);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}

	input[type='number'] {
		width: 150px;
		font-size: var(--fsN);
		background-color: var(--inputBg);
		color: var(--colorMain);
		outline: none;
	}

	input[type='text']:focus {
		background-color: var(--inputFocus);
	}

	select {
		outline: none;
		font-size: var(--fsN);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}

	textarea {
		outline: none;
		font-size: var(--fsN);
		color: var(--colorMain);
		background-color: var(--inputBg);
		width: 85%;
		margin-bottom: 20px;
	}

	.selected_tool {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		font-size: var(--fsS);
		color: var(--buttonColor);
		background-color: var(--buttonHover);
		border: 1px solid white;
		border-radius: 10px;
		cursor: pointer;
		width: clamp(100px, 13vw, 200px);
		height: 30px;
		margin-right: 10px;
	}

	.button_container {
		display: flex;
		width: 100%;
		margin-top: 20px;
		justify-content: center;
		background-color: var(--bg);
	}

	.free_button_container {
		display: flex;
		justify-content: center;
		width: 100%;
		padding: 20px;
		margin-top: 20px;
	}

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		font-size: var(--fsS);
		color: var(--buttonColor);
		border: 1px solid white;
		border-radius: 10px;
		cursor: pointer;
		width: clamp(100px, 13vw, 200px);
		height: 30px;
		margin-right: 10px;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.error {
		display: flex;
		justify-content: center;
		font-size: var(--fsN);
		color: var(--colorPassive);
	}

	.title_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		grid-gap: 15px;
		margin: 20px 0px 30px 15px;
	}

	.set_bg {
		background-color: var(--bg);
	}

	.container {
		padding: 15px;
		height: auto;
		background-color: var(--bg);
	}

	.subtitle {
		font-size: var(--fsN);
		font-weight: bold;
		color: var(--colorMain);
		margin-bottom: 20px;
	}

	.date_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	}

	.date_row {
		display: grid;
		grid-template-columns: clamp(70px, 9vw, 130px) clamp(120px, 21vw, 322px);
		align-items: center;
		margin-left: 20px;
		column-gap: 20px;
		width: 100%;
	}

	.margin_right {
		margin-right: 20px;
	}

	.bold {
		font-weight: bold;
	}

	.underline {
		text-decoration: underline;
	}

	.conf_date_row {
		width: 100%;
		display: grid;
		grid-template-columns: 50% 50%;
	}

	.span_row {
		grid-column-start: 1;
		grid-column-end: 3;
	}
</style>
